import { Button, Checkbox, Modal, Form, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import IconExportCookie from '../../../assets/Images/icons/icon-export-cookie';
import ConsentService from '../../../services/Consent.service';

import useNotify from '../../../context/Notification/useNotify';

const currentYear = new Date().getFullYear();
export default function ModalExport({ detail, open, handelClose }) {
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const [checkedValues, setCheckedValues] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!open) {
            setCheckedValues([]);
        }
    }, [open]);

    const onChange = (e) => {
        // console.log('checked = ', e);
        setCheckedValues(e);
        form.setFieldsValue({ months: e });
    };

    const notify = useNotify();

    const onFinish = async (values) => {
        const payload = {
            period: 'Yearly',
            year: values.year,
            keyword: detail?.keyword,
            consentType: detail?.consentType, //"Consent", "Term & Condition"
            isAccept: detail?.isAccept, //true=Accepted, false=Rejected
            exportType: 'xlsx', //csv, xlsx
            month: values.months.join(','), //"1,5,6" เลขประจำเดือน
        };
        setLoading(true);
        try {
            const { data } = await ConsentService.exportConsentLog(payload);
            if (data) {
                handelClose();
                notify({
                    title: t('common.Success'),
                    description: t('Successfully confirmed data'),
                });
                setLoading(false);
                form.resetFields();
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    const getYeasrList = () => {
        let listYears = [];
        for (let i = currentYear - 5; i < currentYear + 1; i++) {
            listYears.push(i);
        }
        return listYears.reverse();
    };

    return (
        <Modal
            className="_modal"
            footer={false}
            open={open}
            closable={false}
            onCancel={() => {
                handelClose();
                setCheckedValues([]);
                form.resetFields();
            }}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                <IconExportCookie />
                <div className="text-2xl font-semibold">
                    {t('Select the year and month you want to export')}
                </div>
                <div className="max-w-sm">
                    <div>{t('You can choose up to 3 months')}</div>
                    <div>
                        {parse(t('There is a lot of consent information'))}
                    </div>
                </div>
            </div>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                form={form}
                layout="vertical"
                onFinish={onFinish}
                initialValues={{
                    months: [],
                    year: currentYear,
                }}
            >
                <div className="flex justify-between items-center w-full">
                    <Form.Item name="year" label={t('Years')}>
                        <Select
                            size="large"
                            className="text-left text-[14px]"
                            placeholder="Please Select"
                            style={{ width: 140 }}
                        >
                            {getYeasrList()?.map((year) => (
                                <Select.Option key={year} value={year}>
                                    {year}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <div className="">{checkedValues?.length}/3</div>
                </div>
                <Form.Item
                    name="months"
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Checkbox.Group
                        style={{ width: '100%' }}
                        onChange={onChange}
                    >
                        <div className="grid grid-cols-3">
                            {months.map((e) => (
                                <div
                                    key={e.id}
                                    className="col-span-1 border-solid border-[1px] rounded-md mx-2 my-2 py-2 pl-2"
                                    style={{
                                        borderColor: checkedValues.includes(
                                            e.id
                                        )
                                            ? '#7B67FB'
                                            : '#DBDBDB',
                                    }}
                                >
                                    <Checkbox
                                        value={e.id}
                                        disabled={
                                            checkedValues.length > 2
                                                ? checkedValues.includes(e.id)
                                                    ? false
                                                    : true
                                                : false
                                        }
                                        defaultValue={[]}
                                    >
                                        {e.month}
                                    </Checkbox>
                                </div>
                            ))}
                        </div>
                    </Checkbox.Group>
                </Form.Item>
                <div className="flex justify-center items-center space-x-4 my-6">
                    <>
                        <Button
                            type="primary"
                            onClick={() => {
                                handelClose();
                                setCheckedValues([]);
                                form.resetFields();
                            }}
                            size="large"
                            ghost
                            className="px-10"
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            loading={loading}
                            htmlType="submit"
                            size="large"
                            type="primary"
                            className="px-9"
                        >
                            {t('common.Confirm')}
                        </Button>
                    </>
                </div>
            </Form>
        </Modal>
    );
}
let months = [
    {
        id: 1,
        month: 'Jan',
    },
    {
        id: 2,
        month: 'Feb',
    },
    {
        id: 3,
        month: 'Mar',
    },
    {
        id: 4,
        month: 'Apr',
    },
    {
        id: 5,
        month: 'May',
    },
    {
        id: 6,
        month: 'Jun',
    },
    {
        id: 7,
        month: 'Jul',
    },
    {
        id: 8,
        month: 'Aug',
    },
    {
        id: 9,
        month: 'Sep',
    },
    {
        id: 10,
        month: 'Oct',
    },
    {
        id: 11,
        month: 'Nov',
    },
    {
        id: 12,
        month: 'Dec',
    },
];
